import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import ro from "./locales/ro.json";

export const SUPPORTED_LANGS = ["en", "ro"];
export const DEFAULT_LANG = "en";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: DEFAULT_LANG,
        supportedLngs: SUPPORTED_LANGS,
        resources: {
            en: { translation: en },
            ro: { translation: ro },
        },
        detection: {
            order: ["localStorage", "path", "navigator"],
            lookupLocalStorage: "aima_lang",
            caches: ["localStorage"],
        },
        interpolation: { escapeValue: false },
    });

export default i18n;
